<template>
  <a
    href="https://xmind.com/features"
    rel="noopener"
    target="_blank"
    class="shadow-popover-light flex h-10 w-fit items-center gap-2 rounded-lg bg-white px-3 py-1 hover:no-underline sm:px-4"
    @click="onClickPoweredBy"
  >
    <span class="text-text-secondary-light hidden text-sm font-semibold leading-normal sm:inline">{{ $T('Powered by') }}</span>
    <img width="60" height="16" class="object-contain" :src="XmindAiLogo" />
  </a>
</template>

<script setup lang="ts">
import { useTracking } from 'client/composables/use-tracking'
import XmindAiLogo from 'import-files/images/xmind-ai-4.0-brand-light.png'

const { trackClick } = useTracking({ mixpanel: true })

const onClickPoweredBy = () => {
  trackClick('powered_by_xmind_ai')
}
</script>
